import { render, staticRenderFns } from "./urgentGoodsPur.vue?vue&type=template&id=1359efae&scoped=true&"
import script from "./urgentGoodsPur.vue?vue&type=script&lang=js&"
export * from "./urgentGoodsPur.vue?vue&type=script&lang=js&"
import style0 from "./urgentGoodsPur.vue?vue&type=style&index=0&id=1359efae&lang=less&scoped=true&"
import style1 from "./urgentGoodsPur.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1359efae",
  null
  
)

component.options.__file = "urgentGoodsPur.vue"
export default component.exports